import { useState, useEffect } from 'react';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { useStorage64 } from 'hooks/useStorageBase64';
import { useRepairResponse } from 'hooks/useRepairJson'

import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64';
import { dataLayerLogin, dataLayerLogout } from 'functions/dataLayerFunction'

import { postLogin } from 'services/Login';
import { postLoginFacebook, getLoginFacebook } from 'services/postLoginFacebook'
import { postRegister } from 'services/postRegister'
import { postLogoutOldPortal } from 'services/postLogin';

// This code is for shopping cart flux
import { useStore } from 'store';
import { setLoggedAfterAddingTemporaryProduct } from 'store/actions/externalGiftTable';
import useQuery from './useQuery';
// This code is for shopping cart flux

export function useLogin(){

    const [successForm, getSuccessForm] = useState(false);
    const [dataForm, getDataForm] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isLoged, setIsLoged] = useStorage64('session_token', '');
    const [isTrueWish, setIsTrueWish] = useStorage64('session_token', '');
    const [, setIsCart] = useStorage64('idCarrito', '');
    const [isTrueProd, setIsTrueProd] = useStorage64('idCarrito', '');
    const [errorMessage, setErrorMessage] = useState();
    const [statusCode, setStatusCode] = useState();
    const wishlistAfter = decodeStorage('wishlistAfter');
    const productAfter = decodeStorage('productAfter');
    const typeButton = decodeStorage('typeButton');
    const location = useLocation();
    const history = useHistory();
    const redir = location.search;
    const hostName = window.location.origin;
    const domain = window.location.hostname
    //let dominio = window.location.host
    //const domain = dominio.replace(dominio.split('.')[0], '')

    // valida si tienes sesion activa y regresa 1 al historico
    useEffect(() => {
        if (isLoged) {
            if (redir.split('=')[0] === '?redirect') {
                if(redir.split('=')[1].split('/')[2] === "mis-pedidos" || redir.split('=')[1].split('/')[3] === "mis-pedidos"){
                    setTimeout(function () {
                        window.location.href = redir.split('=')[1].replace(hostName, '')
                    }, 500)
                }
                else if(redir.split('=')[1].split('/')[1] === "Caja" || redir.split('=')[1].split('/')[2] === "Caja" || redir.split('=')[1].split('/')[3] === "Caja"){
                    setTimeout(function () {
                        window.location.href = redir.split('=')[1].replace(hostName, '')
                    }, 500)
                }
                else if(redir.split('=')[1].split('/')[2] === "mis-datos" || redir.split('=')[1].split('/')[3] === "mis-datos"){
                    setTimeout(function () {
                        window.location.href = redir.split('=')[1].replace(hostName, '')
                    }, 500)
                }
                else{
                    setTimeout(function () {
                        history.replace(redir.replace(`?redirect=${hostName}`, ''))
                    }, 500)
                }
            }
            else {
                setTimeout(function () {
                    history.replace('/')
                }, 500)
            }
        } else {
            setLoading(false)
        }
    }, [isLoged])

    // manda la peticion al servicio de login
    const [, setOldLogin] = useState()
    useEffect(() => {
        if (dataForm) {
            // postLoginOldPortal({ email: dataForm.usuario, password: dataForm.contrasena })
            // .then(setOldLogin)
            setTimeout(function () {
                postLogin({ raw: {password: dataForm.contrasena, email: dataForm.usuario} })
                .then(getSuccessForm)
            }, 100)
        }
        return
    }, [dataForm])

// This code is for shopping cart flux
  const [productOfNotLoggedUser, dispatch] = useStore(
    (state) => state.externalGiftTable.temporalProductOfNotLoggedUser
  );
  const query = useQuery();
// This code is for shopping cart flux


    // recibe la respuesta del servicio de Login
    const [okLoginResponse, setOkLoginResponse] = useState(false)
    const [tokenService, setTokenService] = useState()
    useEffect(() => {
        //console.log('successForm', successForm)
        if (successForm) {
            if(successForm.statusCode === 200){
                if(successForm.data){
                    if(successForm.data.data){
                        if(successForm.data.data.session_token){
                            
                            removeStorage('telefono_usuario')
                            removeStorage('saldoTelmexService')
                        
                            if(successForm.data.data.access_token){
                                setTokenService('access_token',successForm.data.data.access_token)
                                encodeStorage('access_token',successForm.data.data.access_token)
                                encodeStorage('refresh_token',successForm.data.data.refresh_token)
                                document.cookie = `access_token=${successForm.data.data.access_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                                document.cookie = `refresh_token=${successForm.data.data.refresh_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`

                                let tokenJWT = JSON.parse( window.atob(successForm.data.data.access_token.split('.')[1]) )
                                let tokenRefreshJWT = JSON.parse( window.atob(successForm.data.data.refresh_token.split('.')[1]) )

                                let profileData = {
                                    nombre: tokenJWT.preferred_username,
                                    correo: tokenJWT.email,
                                    idClaro: tokenJWT.userid
                                }
                                
                                encodeStorage('access_token_exp', tokenJWT.exp)
                                encodeStorage('refresh_token_exp', tokenRefreshJWT.exp)
                                encodeStorage('profileData', profileData)
                            }

                            setTimeout(function () {
                                setOkLoginResponse(true)
                            }, 1000)

                            // This code is for shopping cart flux
                            const redirect = query.get('redirect');

                            if (productOfNotLoggedUser && redirect) {
                                dispatch(setLoggedAfterAddingTemporaryProduct(true));
                            }
                            // This code is for shopping cart flux


                        }
                    }
                }
            }
            else if (successForm.statusCode === 401) {
                setLoading(false)
                errorLogin('')
            }
            else if (successForm.statusCode === 500) {
                setLoading(false)
                setStatusCode(500)
            }
        }
    }, [successForm])

    // Bloque de facebook
    const [flaglogin, setFlagLogin] = useState(false);
    const [respFace, setRespFace] = useState()
    const [dataFB, setDataFB] = useStorage64('dataFacebook', '')
    const [, setErrorFacebook] = useState(false)
    const reciveDataFacebook = (response) => {
        setLoading(true)
        setRespFace(response)
    }
    useEffect(() => {
        if (respFace) {
            if (respFace.accessToken && respFace.email) {
                if ((typeof (respFace.accessToken) === 'string') && typeof (respFace.email) === 'string') {
                    removeStorage('telefono_usuario')
                    removeStorage('saldoTelmexService')
                    setFlagLogin(true)
                    setDataFB(respFace)
                    setErrorFacebook(false)
                } else {
                    setFlagLogin(false);
                    getSuccessForm({ message: 'El usuario no tiene los permisos necesarios para iniciar sesión con facebook' })
                }
            } else {
                setFlagLogin(false);
                getSuccessForm({ message: 'El usuario no tiene los permisos necesarios para iniciar sesión con facebook' })
            }
        }
    }, [respFace])

    const [successFB, getSuccessFB] = useState(false)
    useEffect(() => {
        if (flaglogin === true) {
            if (dataFB) {
                getLoginFacebook({ email: dataFB.email })
                    .then(setSuccessFBOldPortal)
                setTimeout(function () {
                    postLoginFacebook({ raw: { "email": dataFB.email, "access_token": dataFB.accessToken } })
                        .then(getSuccessFB)
                }, 100)
            }
        }
        return
    }, [flaglogin, dataFB])
    const [, setSuccessFBOldPortal] = useState()
    useEffect(() => {
        if (successFB) {
            //console.log('successFB', successFB)
            if(successFB.data){
                if (successFB.data.session_token) {
                    getSuccessForm({token: successFB.data.session_token, idCarrito: successFB.data.hash_cart})
                    removeStorage('telefono_usuario')
                    removeStorage('saldoTelmexService')

                    setTimeout(function () {
                        setOkLoginResponse(true)
                    }, 1000)
                }
            }
            else if (successFB.error >= 400 || successFB.error <= 499 ) {
                getSuccessForm({message: successFB.message})
                errorLogin()
                setLoading(false)
            }
            else if (successFB.error === 500) {
                getSuccessForm({message: successFB.message})
                setLoading(false)
                setStatusCode(500)
            }
        }
    }, [successFB])


    //- Evalua si viene desde un producto o wishlist
    useEffect(() => {
        if (okLoginResponse) {
            if (wishlistAfter) {
                setIsTrueWish(successForm.data.data.session_token)
            } else if (productAfter) {
                setIsCart(successForm.data.data.cart_hash)
                login()
                if (typeButton === 'buttonBuyNow') {
                    encodeStorage('okBuyProductAfter', true)
                } else if (typeButton === 'buttonAddToCart') {
                    encodeStorage('okCartProductAfter', true)
                }
                setLoading(false)
            } else {
                //console.log('nada de wish ni prodxuto')
                login()
                setLoading(false)
            }
        }
    }, [okLoginResponse])


    // recibe los datos del formulario
    const reciveDataLogin = (val) => {
        getDataForm(val)
        setLoading(true)
    }

    // funcion cuando todo sale OK al login
    const login = () => {
        // localStorage.clear()
        removeStorage('session_token')
        removeStorage('idCarrito')
        removeStorage('sendDirections')
        removeStorage('total_items')
        removeStorage('profileData')
        removeStorage('productsWishlist')
        removeStorage('cartData')
        removeStorage('selectId')
        removeStorage('shipping')
        removeStorage('dirPredeterminada')
        removeStorage('codigoPostal')
        removeStorage('existDirPredeterminada')
        removeStorage('telefono_usuario')
        removeStorage('saldoTelmexService')
        removeStorage('cartFormEm')
        removeStorage('busquedas')
        removeStorage('dataFacebook')
        removeStorage('wishlistAfter')
        // removeStorage('typeButton')
        // removeStorage('productAfter')
        // removeStorage('okCartProductAfter')
        // removeStorage('okBuyProductAfter')
        document.cookie = `SSID=${successForm.data.data.session_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
        document.cookie = `SCID=${successForm.data.data.cart_hash};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
        document.cookie = `token_cart=${successForm.data.data.cart_hash};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
        document.cookie = `token_login=${successForm.data.data.session_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
        setIsLoged(successForm.data.data.session_token)
        setIsCart(successForm.data.data.cart_hash)
        window.localStorage.removeItem("closebtnMT-detalle")
        window.localStorage.removeItem("closebtnMT-home")
        dataLayerLogin()
    }

    // funcion cuando regresa algun error con el login
    const errorLogin = () => {
        setErrorMessage('Usuario y/o Contraseña no validos')
    }

    const dataLogin = {
        isLoged,
        loading,
        errorMessage,
        redir,
        statusCode
    }

    return {
        dataLogin,
        reciveDataLogin,
        reciveDataFacebook
    }
}

export function useLogout(){
    
    const history = useHistory();
    const domain = window.location.hostname
    //let dominio = window.location.host
    //const domain = dominio.replace(dominio.split('.')[0], '')

    const logOut = (redirect = true) => {

        //  console.log('useLogin - logOut')
        removeStorage('session_token')
        removeStorage('idCarrito')
        removeStorage('sendDirections')
        removeStorage('total_items')
        removeStorage('profileData')
        removeStorage('productsWishlist')
        removeStorage('cartData')
        removeStorage('selectId')
        removeStorage('shipping')
        removeStorage('dirPredeterminada')
        removeStorage('codigoPostal')
        removeStorage('existDirPredeterminada')
        removeStorage('telefono_usuario')
        removeStorage('saldoTelmexService')
        removeStorage('cartFormEm')
        removeStorage('busquedas')
        removeStorage('dataFacebook')
        removeStorage('typeButton')
        removeStorage('wishlistAfter')
        removeStorage('productAfter')
        removeStorage('okCartProductAfter')
        removeStorage('okBuyProductAfter')
        removeStorage('access_token')
        removeStorage('refresh_token')
        removeStorage('refresh_token_exp')
        removeStorage('access_token_exp')
        
        window.localStorage.removeItem("closebtnMT-detalle")
        window.localStorage.removeItem("closebtnMT-home")

        document.cookie = `SSID=;Max-Age=${0};Path=/;Domain=${domain};`
        document.cookie = `SCID=;Max-Age=${0};Path=/;Domain=${domain};`
        document.cookie = `access_token=;Max-Age=${0};Path=/;Domain=${domain};`
        document.cookie = `refresh_token=;Max-Age=${0};Path=/;Domain=${domain};`
        
        document.cookie = `token_login=;Max-Age=${0};Path=/;Domain=${domain};`;
        document.cookie = `token_cart=;Max-Age=${0};Path=/;Domain=${domain};`;
        document.cookie = `token_api_manager=;Max-Age=${0};Path=/;Domain=${domain};`;
        
        postLogoutOldPortal();
        dataLayerLogout();
        if (redirect) {
            setTimeout(function () {
                if (history.location.pathname === "/")
                    window.location.reload();
                else if (!history.location.pathname.includes("login")) {
                    history.replace("/");
                }
                else {
                    window.location.reload();
                }
            }, 300)
        }
    }

    return {
        logOut
    }
}

export function useRegistro(){

    const {
        dataLogin,
        reciveDataLogin,
        reciveDataFacebook
    } = useLogin()

    const [isLoged,] = useState(dataLogin.isLoged)
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState()
    const [redir,] = useState(dataLogin.redir)
    const [statusCode, setStatusCode] = useState()

    const [successForm, getSuccessForm] = useState(false)
    const [successRegister, getSuccessRegister] = useState(false)
    const [dataForm, getDataForm] = useState(false)
    const {
        responseData,
        setData
    } = useRepairResponse()

    // manda la peticion al servicio de Registro
    useEffect(() => {
        if (dataForm) {
            postRegister({ raw: dataForm })
            .then(getSuccessForm)
        }
        return
    }, [dataForm])

    // recibe la respuesta del servicio de registro
    useEffect(() => {
        if (successForm) {
            if(successForm.statusCode === 200){
                if(typeof(successForm.data) === 'object'){
                    if(successForm.data){
                        if (successForm.data.code == 10) {
                            setErrorMessage(successForm.data.msg)
                            setLoading(false)
                            window.scrollTo(0, 0)
                        } else if (successForm.data.code == 11) {
                            getSuccessRegister(true)
                            setLoading(true)
                        }
                    }
                }
                if(typeof(successForm.data) === 'string'){
                    setData(successForm.data)
                    setLoading(false)
                }
                else{
                    setLoading(false)
                }
            }else if(successForm.statusCode >= 500){
                setStatusCode(successForm.statusCode)
                setLoading(false)
            }
        }
    }, [successForm])

    //corrige respuesta si regresa un string
    useEffect(()=>{
        if(responseData){
            if (responseData.code == 10) {
                getSuccessRegister(true)
                setErrorMessage(responseData.msg)
                setLoading(false)
                window.scrollTo(0, 0)
            } else if (responseData.code == 11) {
                getSuccessRegister(true)
                setLoading(true)
            }
        }
    },[responseData])


    // manda los datos del registro al login
    const [respFace, setRespFace] = useState()
    useEffect(() => {
        let raw = {usuario: dataForm.correo, contrasena: dataForm.password}
        if (successRegister) {
            reciveDataLogin(raw)
        }else if(respFace){
            reciveDataFacebook(respFace)
        }
    }, [successRegister, respFace])


    // recibe los datos del formulario
    const reciveDataRegistro = (val) => {
        getDataForm(val)
        setLoading(true)
    }

    const reciveDataRegistroFacebook = (response) => {
        setLoading(true)
        setRespFace(response)
    }

    const dataRegistro = {
        isLoged,
        loading,
        errorMessage,
        redir,
        statusCode
    }

    return {
        dataRegistro,
        reciveDataRegistro,
        reciveDataRegistroFacebook
    }
}

export function useRegistroGuest(){

    const {
        dataLogin,
        reciveDataLogin
    } = useLogin()

    //  console.log("En useRegistroGuest...............");
    //  console.log("dataLogin",dataLogin);
    //  console.log("reciveDataLogin",reciveDataLogin);

    const [isLoged,setIsLoged] = useState(dataLogin.isLoged)
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState()
    const [redir, setRedirect] = useState(dataLogin.redir)
    const [statusCode, setStatusCode] = useState()

    const [successForm, getSuccessForm] = useState(false)
    const [successRegisterGuest, getSuccessRegisterGuest] = useState(false)
    const [dataForm, getDataForm] = useState(false)
    const {
        responseData,
        setData
    } = useRepairResponse()

    // guardando datos en localstorage
    useEffect(() => {
        if (dataForm) {
            //  Guardando en localStorage
            //  console.log("guest_email",dataForm.correo);
            //  console.log("guest_phone_number",dataForm.cellphone);
            localStorage.setItem("guest_email", dataForm.correo);
            localStorage.setItem("guest_phone_number", dataForm.cellphone);
            //successForm.statusCode = 200;
            getSuccessRegisterGuest(true)
            setLoading(true)
            //  console.log("successRegisterGuest",successRegisterGuest);
            setIsLoged(true);

            const urlParams = new URLSearchParams(window.location.search);
            const redirect = urlParams.get('redirect');
            //  console.log("redirect",redirect);
            window.location.href = redirect;
        }
        return
    }, [dataForm])

    // recibe los datos del formulario
    const reciveDataRegistro = (val) => {
        getDataForm(val)
        setLoading(true)
    }

    const dataRegistro = {
        isLoged,
        loading,
        errorMessage,
        redir,
        statusCode
    }
    //  console.log("dataRegistro",dataRegistro);
    //  console.log("isLoged en useRegistroGuest",isLoged);
    return {
        dataRegistro,
        reciveDataRegistro
    }
}